<template>
  <div id="HeaderContainer" :style="{ backgroundColor: getColor.primaryColor }">
    <!-- <header id="Header" :style="{ backgroundImage: `url(${require(`../../images/logos/${logoName}`)})` }"> -->
    <header id="Header">
      <button id="back" class="header-button" @click="backPage" v-if="isBack"></button>
      <span class="header-title">PAYGATEWAY</span>
      <button id="close" class="header-button" @click="closePage"></button>
    </header>
  </div>
</template>

<script>
import vuex from 'vuex'

export default {
  data() {
    return {
      isBack: false,
      logoName: 'hello-pay-header.png'
    }
  },
  computed: {
    ...vuex.mapGetters({
      'getColor': 'style/getColor'
    })
  },
  watch: {
    '$route' (to, from) {
      let name = to.name;

      if(name == 'Selector') {
        this.isBack = false;
      } else {
        this.isBack= true;
      }
    }
  },
  created() {
    this.initHeader()
  },
  methods: {
    ...vuex.mapActions({
      'TOGGLE_CLOSE_WINDOW': 'display/TOGGLE_CLOSE_WINDOW'
    }),
    backPage() {
      this.$router.go(-1)
    },
    closePage() {
      this.TOGGLE_CLOSE_WINDOW();
    },
    initHeader() {
      let currentName = this.$router.history.current.name;
      if(currentName === 'Selector' || currentName === 'Domestic' || currentName === "Global" || currentName === "Certification") {
        this.isBack = false;
      } else {
        this.isBack= true;
      }
    }
  }
}
</script>

<style lang="scss">
#HeaderContainer {
  z-index: 1000;
  position: fixed;
  width: 100%;
  height: 44px;

  #Header {
    @include basic-display;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    height: 100%;

    // background-image: url('https://via.placeholder.com/165x44?text=Logo+Place');
    background-position: center;
    background-size: 165px 44px;
    background-repeat: no-repeat;

    .header-button {
      position: absolute;
      width: 44px;
      height: 44px;

      background-color: inherit;
      background-position: center;
      background-size: 44px;
      background-repeat: no-repeat;
    }

    #back {
      left: 0;

      background-image: url('../../images/back-nor.svg');
    }

    #close {
      right: 0;

      background-image: url('../../images/close-nor.svg');
    }

    .header-title {
      font-size: 17px;
      font-weight: bold;
      color: white;
    }
  }
}
</style>